// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9879c058"};